module.exports = __webpack_public_path__ + "img/Procedures_Icon_Down.22316ebb.svg";